import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export class BetterValidators {

    public static requiredString(control: AbstractControl): ValidationErrors | null {
        return control.value?.trim().length ?? 0 > 0 ? null : {requiredString: true};
    }

    public static dateMin(minDate: Date): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (!control.value) return null;

            const value = new Date(control.value);
            return value >= minDate ? null : { dateMin: { min: minDate, actual: value } };
        };
    }

    public static dateRangeValidator(
        startKey: string,
        endKey: string,
        allowEqual: boolean = true
    ): ValidatorFn {

        return (group: AbstractControl): ValidationErrors | null => {

            const startControl = group.get(startKey);
            const endControl = group.get(endKey);

            if (!startControl || !endControl) {
                return null;
            }

            const start = startControl.value;
            const end = endControl.value;

            if (!start || !end) {
                return null;
            }

            const startDate = new Date(start);
            const endDate = new Date(end);

            const isValid = allowEqual
                ? startDate <= endDate
                : startDate < endDate;

            return isValid ? null : { dateRangeInvalid: true };
        };
    }

}
